import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Header,
  SectionTitle,
  ProgramName,
  Details,
  Row,
  ColLabel,
  ColValue,
  Divider,
} from "./styles";

function ProductTransfer({ transfer }) {
  const data =
    transfer ||
    {
      title: "Transferência de pontos",
      program: "LATAM PASS",
      transferredPoints: 60000,
      partnerPoints: 60000,
    };

  const formatPoints = (value) => value.toLocaleString("pt-BR");

  return (
    <Container role="region" aria-label="Resumo da transferência de pontos">
      <Header>
        <SectionTitle>{data.title}</SectionTitle>
      </Header>

      <ProgramName aria-label="Programa de fidelidade">{data.program}</ProgramName>

      <Divider />

      <Details>
        <Row>
          <ColLabel>Pontuação transferida</ColLabel>
          <ColValue>{formatPoints(data.transferredPoints)}</ColValue>
        </Row>
        <Row>
          <ColLabel>Pontuação no programa parceiro</ColLabel>
          <ColValue>{formatPoints(data.partnerPoints)}</ColValue>
        </Row>
      </Details>
    </Container>
  );
}

ProductTransfer.propTypes = {
  transfer: PropTypes.shape({
    title: PropTypes.string,
    program: PropTypes.string,
    transferredPoints: PropTypes.number,
    partnerPoints: PropTypes.number,
  }),
};

ProductTransfer.defaultProps = {
  transfer: null,
};

export default ProductTransfer;


